module.exports = __webpack_public_path__ + "static/media/usd-square.c189577c.svg";